import { useIsFetching } from '@tanstack/react-query';

import { useShowDelayedLoading } from '@telialt/common-hooks/src/useShowDelayedLoading';

import { SEARCH_QUERY_KEYS } from '../constants';

export const useIsLoadingSearchSuggestions = () => {
    const isQueryKeysFetching = useIsFetching({ queryKey: [SEARCH_QUERY_KEYS.QUERY_KEYS] });
    const isSuggestionsFetching = useIsFetching({ queryKey: [SEARCH_QUERY_KEYS.SEARCH_SUGGESTION], exact: false });

    const isLoading = Boolean(isQueryKeysFetching + isSuggestionsFetching);
    const isLoadingDelayed = useShowDelayedLoading(isLoading, 1000);

    return isLoadingDelayed;
};
